{
  "intro": "Public keys you can put on new servers, so you sign in with your private key instead of a password. Keys are stored in this Hetzner project; adding one costs nothing.",
  "add": "Add SSH key",
  "addLead": "Paste the public key (the .pub file) or load it from a file. The private key never leaves your computer.",
  "publicKey": "Public key",
  "publicKeyHint": "One line starting with ssh-ed25519, ssh-rsa or ecdsa-sha2-…. No key yet? Run: ssh-keygen -t ed25519",
  "publicKeyWhy": "The server keeps the public key; whoever holds the matching private key can sign in. Sharing the public key is safe.",
  "privateKey": "This is a private key. Never paste it anywhere: use the .pub file next to it.",
  "invalid": "Hetzner does not accept this key. Check that the whole line was copied.",
  "duplicate": "This key or this name is already in the project.",
  "fromFile": "Load from file",
  "name": "Name",
  "nameHint": "So you recognize the key later, e.g. the device it lives on.",
  "submit": "Add key",
  "added": "SSH key “{{name}}” added",
  "empty": "No SSH keys yet",
  "emptyLead": "Add your public key once, then pick it when you create a server: you sign in without a password, and nobody can guess one.",
  "fingerprint": "Fingerprint",
  "fingerprintHint": "A short checksum of the key; compare it with ssh-keygen -lf -E md5 <file>.pub to be sure it is yours.",
  "type": "Type",
  "created": "Added",
  "copy": "Copy public key",
  "copied": "Public key copied",
  "rename": "Rename",
  "delete": "Delete",
  "deleteTitle": "Delete the SSH key “{{name}}”?",
  "deleteNew": "New servers can no longer be created with this key.",
  "deleteExisting": "Servers that already have it keep it: remove it from their ~/.ssh/authorized_keys yourself if access must end.",
  "deleted": "SSH key “{{name}}” deleted"
}
